import { LazyLoadImage, LazyLoadImageProps } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

function Image(props: LazyLoadImageProps) {
  return <LazyLoadImage {...props} />;
}

export default Image;
